import { Option } from '@cmg/common';
import { SelectOption } from '@cmg/design-system';

import { Sector } from '../graphql';

export const sectorLabels = {
  [Sector.BasicMaterials]: 'Basic Materials',
  [Sector.Consumer]: 'Consumer',
  [Sector.Energy]: 'Energy',
  [Sector.FinancialServices]: 'Financial Services',
  [Sector.Healthcare]: 'Healthcare',
  [Sector.Industrials]: 'Industrials',
  [Sector.Other]: 'Other',
  [Sector.RealEstate]: 'Real Estate',
  [Sector.Tmt]: 'TMT',
  [Sector.Utilities]: 'Utilities',
};

export enum exchangeEnum {
  XNAS = 'NASDAQ',
  XNYS = 'NYSE',
}

export const sectorOptions = Object.values(Sector).map<Option<Sector>>(sector => ({
  label: sectorLabels[sector],
  value: sector as Sector,
}));

export const visibilityLabels = {
  Internal: 'Internal Only',
  Public: 'Public on XC',
};

export const visibilityOptions: SelectOption<boolean>[] = [
  { label: visibilityLabels.Internal, value: true },
  { label: visibilityLabels.Public, value: false },
];

export const visibilityDescriptions = {
  [visibilityLabels.Internal]:
    'Private to your firm. No external collaboration. Internal Only deals cannot be modified for publish/collaboration.',
  [visibilityLabels.Public]:
    'Disclosed publicly upon launch/publish. External collaboration with syndicate & buy-side.',
};

export const DEBOUNCE_TIMEOUT = 500;

/**
 * Comomon options for non-editable grids
 */
export const gridFooterMinHeight = 100;

const nonEditableGridOptionsBase = {
  // rowBuffer is the amount of additional rows rendered outside what is currently in view. Since it is rather expensive to render cellRendererFramework
  // cells, limiting this helps keep the overall cell render times low.
  rowBuffer: 5,
};

export const nonEditableGridOptions = {
  ...nonEditableGridOptionsBase,
  rowHeight: 32,
};
